import { render, staticRenderFns } from "./Rbottom.vue?vue&type=template&id=4e748c45&scoped=true&"
import script from "./Rbottom.vue?vue&type=script&lang=js&"
export * from "./Rbottom.vue?vue&type=script&lang=js&"
import style0 from "./Rbottom.vue?vue&type=style&index=0&id=4e748c45&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e748c45",
  null
  
)

export default component.exports